import { demoModeAtom } from '@/global-store';
import { Box } from '@mui/material';
import { useAtom } from 'jotai';
import NavBadge from '../NavBadge';

function LogoSection({ dark }: { dark?: boolean }) {
  const [demoMode] = useAtom(demoModeAtom);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        aria-hidden='true'
        component='img'
        src={
          dark
            ? 'https://assets.eye-able.com/dashboard-assets/icons/Icon_Dashboard_eye-able_black.svg'
            : 'https://assets.eye-able.com/dashboard-assets/icons/Icon_Dashboard_eye-able_white.svg'
        }
        sx={{
          width: 34,
          bgcolor: 'transparent',
        }}
      />
      <Box
        sx={[
          {
            whiteSpace: 'nowrap',
            position: 'relative',
            fontSize: '1.15rem',
            mr: 3,
          },
          dark
            ? {
                color: '#000',
              }
            : {
                color: '#fff',
              },
        ]}
      >
        <b>Eye-Able</b>

        <span style={{ position: 'absolute', right: '-12px', top: '-4px' }}>
          &#174;
        </span>
      </Box>
      {demoMode ? <NavBadge text='demo' /> : null}
    </Box>
  );
}

export default LogoSection;
